let bsParams = {

  publication:'',     // 连续型电子出版物名称 中文
	publicationEnglish:'',     // 连续型电子出版物名称 英文
	category:'',     // 类别（选择项）
	recordType:'',     // 文种
	periodicals:'',     // 刊期（选择项）
	cn:'',     // 刊号
	issn:'',     // 国际刊号
	approvalTime:'',     // 批准时间
	mediaForm:'',     // 媒体形态（选择项）
  mediaFormQT:'',
	issueQuantity:'',     // 发行数量（套）
	unitPrice:'',     // 单价
	isSampleDelivery:'',     // 是否按规定向国家版本馆、国家图书馆缴送样本
	publicationScope:'',     // 出版范围
	issueScope:'',     // 发行范围
	readers:'',     // 读者对象

  id:'',     // id
	publishMaterialId:'',     // publishMaterialId
	publishId:'',     // 出版单位ID

}


let paramsRule = {

    publication:[
    	{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
    ],     // 连续型电子出版物名称 中文
	publicationEnglish:[
		{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 连续型电子出版物名称 英文
	category:[
		{ required:true, message:'请选择', trigger:'change' },
	],     // 类别（选择项）
	recordType:[
		{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 文种
	periodicals:[
		{ required:true, message:'请选择', trigger:'change' },
	],     // 刊期（选择项）
	cn:[
		{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 刊号
	issn:[
		{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 国际刊号
	approvalTime:[
		{ required:true, message:'请选择', trigger:'change' },
	],     // 批准时间
	mediaForm:[
		{ required:true, message:'请选择', trigger:'change' },
	],     // 媒体形态（选择项）
  mediaFormQT:[
		    { required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     //
	issueQuantity:[
		{ required:true, message:'请选择', trigger:'change' },
	],     // 发行数量（套）
	unitPrice:[
		{ required:true, message:'请选择', trigger:'change' },
	],     // 单价
	isSampleDelivery:[
		{ required:true, message:'请选择', trigger:'change' },
	],     // 是否按规定向国家版本馆、国家图书馆缴送样本
	publicationScope:[
		{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 出版范围
	issueScope:[
		{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 发行范围
	readers:[
		{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 读者对象

    id:'',     // id
	publishMaterialId:'',     // publishMaterialId
	publishId:'',     // 出版单位ID

}

export { bsParams,paramsRule }



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsSEt1.js